import { Injectable } from '@angular/core';
import { map, type Observable } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { type CreateToDo } from '../models/create-to-do';
import { type CreateCustomerContact } from '../models/create-customer-contact';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(private readonly http: HttpClient) {}

  createToDo(createToDoRequest: CreateToDo): Observable<any> {
    const url = environment.OASUrl() + '/customer/create-todo';
    const res = this.http.post(url, createToDoRequest);
    return res.pipe(
      map((data: any) => {
        if (data.Error === null) {
          return data.Status;
        } else {
          throw new Error(data.Error?.ErrorCode);
        }
      }),
    );
  }

  createCustomerContact(createContactRequest: CreateCustomerContact): Observable<any> {
    const url = environment.OASUrl() + '/customer/create-contact';
    const res = this.http.post(url, createContactRequest);
    return res.pipe(
      map((data: any) => {
        if (data.Error === null) {
          return data.Status;
        } else {
          throw new Error(data.Error?.ErrorCode);
        }
      }),
    );
  }

  unauthCreateCustomerContact(createContactRequest: CreateCustomerContact): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        ClientId: environment.ClientId,
      }),
    };
    const url = environment.OASUrl() + '/unauthcustomer/unauth-create-contact';
    const res = this.http.post(url, createContactRequest, httpOptions);
    return res.pipe(
      map((data: any) => {
        if (data.Error === null) {
          return data.Status;
        } else {
          throw new Error(data.Error?.ErrorCode);
        }
      }),
    );
  }
}
